import { __decorate, __metadata } from "tslib";
import { DiningOptionEnum, IsGreaterThanOrEqual, IsNotEmptyObjectWithLVS } from '@goparrot/common';
import { Expose, Type } from 'class-transformer';
import { ArrayUnique, IsArray, IsBoolean, IsEnum, IsInstance, IsNumber, IsOptional, IsString, Min, ValidateNested } from 'class-validator';
import { StoreItemsExposeGroup } from '../enum';
import { ReadAbstractItemMetadataDto } from './ReadAbstractItemMetadataDto';
import { ReadStoreItemMetadataCategoryDto } from './ReadStoreItemMetadataCategoryDto';
import { ReadStoreItemMetadataPosDto } from './ReadStoreItemMetadataPosDto';
import { ReadWeightDto } from './ReadWeightDto';
export class ReadStoreItemMetadataDto extends ReadAbstractItemMetadataDto {
}
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    Type(() => ReadStoreItemMetadataPosDto),
    IsInstance(ReadStoreItemMetadataPosDto, { always: true }),
    ValidateNested({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    __metadata("design:type", ReadStoreItemMetadataPosDto)
], ReadStoreItemMetadataDto.prototype, "pos", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "menus", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    Type(() => ReadWeightDto),
    IsOptional({ always: true }),
    ValidateNested({ each: true, always: true }),
    IsInstance(ReadWeightDto, { each: true, always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    __metadata("design:type", ReadWeightDto)
], ReadStoreItemMetadataDto.prototype, "weight", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({ allowInfinity: false, allowNaN: false }, { always: true }),
    Min(0, { always: true, message: 'prepTime must be greater than 0' }),
    __metadata("design:type", Number)
], ReadStoreItemMetadataDto.prototype, "prepTime", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({
        groups: [StoreItemsExposeGroup.CREATE, StoreItemsExposeGroup.BATCH_CREATE, StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH],
    }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemMetadataDto.prototype, "show_order", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemMetadataDto.prototype, "printOrder", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemMetadataDto.prototype, "additional_info", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemMetadataDto.prototype, "additional_title", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemMetadataDto.prototype, "calories", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "categories", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    Type(() => ReadStoreItemMetadataCategoryDto),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    ValidateNested({ each: true, always: true }),
    IsInstance(ReadStoreItemMetadataCategoryDto, { each: true, always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "categoryProperties", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    Min(1),
    __metadata("design:type", Number)
], ReadStoreItemMetadataDto.prototype, "minQuantity", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    Min(1),
    IsGreaterThanOrEqual('minQuantity', { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemMetadataDto.prototype, "maxQuantity", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemMetadataDto.prototype, "category", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemMetadataDto.prototype, "changeString", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemMetadataDto.prototype, "comment", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
        each: true,
    }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "course", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemMetadataDto.prototype, "course_order", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "cuisine", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "diet_type", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "dishType", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemMetadataDto.prototype, "dish_index", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "flavor", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "ingredients", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemMetadataDto.prototype, "ingredients_description", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "preparation_method", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "property", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemMetadataDto.prototype, "RecommendedDishes_show_order", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemMetadataDto.prototype, "recommended_eoo_show_order", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "serving_method", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "serving_time", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    IsArray({ always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "similar_items", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadStoreItemMetadataDto.prototype, "containsAlcohol", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsEnum(DiningOptionEnum, { each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemMetadataDto.prototype, "diningOptions", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true, each: true }),
    __metadata("design:type", String)
], ReadStoreItemMetadataDto.prototype, "notes", void 0);
//# sourceMappingURL=ReadStoreItemMetadataDto.js.map